import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { CentersTab } from '../../tabs/contractTabs/CentersTab';
import DrgTab from '../../tabs/contractTabs/DrgTab';
import CptTab from '../../tabs/contractTabs/CptTab';
import CarveOutTab from '../../tabs/contractTabs/CarveOutTab';
import RatesTab from '../../tabs/contractTabs/RatesTab';
import MedicareBasedConfigTab from '../../tabs/contractTabs/MedicareBasedConfigTab';
import RulesTab from '../../tabs/contractTabs/RulesTab';
import { setSelectedContractTabIndex } from '../../../../../services/ContractService/contractSlice';
import { RootState } from '../../../../../app/store';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`contract-tabpanel-${index}`}
    aria-labelledby={`contract-tab-${index}`}
  >
    {value === index && (
      <Box sx={{ pt: 3, pb: 1.5, px: 1 }}>
        {children}
      </Box>
    )}
  </div>
);

const ContractTabSection: React.FC = () => {
  const dispatch = useDispatch();
  const selectedTab = useSelector((state: RootState) => state.contract.selectedContractTabIndex);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    dispatch(setSelectedContractTabIndex(newValue));
  };

  const tabs = [
    { label: 'Centers', id: 'centers' },
    { label: 'DRG', id: 'drg' },
    { label: 'CPT', id: 'cpt' },
    { label: 'Carve Outs', id: 'carveouts' },
    { label: 'Rates', id: 'rates' },
    { label: 'Medicare Based Config', id: 'medicare' },
    { label: 'Rules', id: 'rules' }
  ];

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={selectedTab} 
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="contract configuration tabs"
          sx={{
            minHeight: '40px',
            '& .MuiTab-root': {
              minHeight: '40px',
              padding: '6px 16px',
              fontSize: '0.875rem'
            }
          }}
        >
          {tabs.map((tab, index) => (
            <Tab 
              key={tab.id}
              label={tab.label} 
              id={`contract-tab-${index}`}
              aria-controls={`contract-tabpanel-${index}`}
            />
          ))}
        </Tabs>
      </Box>

      {/* Centers Tab */}
      <CustomTabPanel value={selectedTab} index={0}>
        <CentersTab />
      </CustomTabPanel>

      {/* DRG Tab */}
      <CustomTabPanel value={selectedTab} index={1}>
        <DrgTab />
      </CustomTabPanel>

      {/* CPT Tab */}
      <CustomTabPanel value={selectedTab} index={2}>
        <CptTab />
      </CustomTabPanel>

      {/* Carve Outs Tab */}
      <CustomTabPanel value={selectedTab} index={3}>
        <CarveOutTab />
      </CustomTabPanel>

      {/* Rates Tab */}
      <CustomTabPanel value={selectedTab} index={4}>
        <RatesTab />
      </CustomTabPanel>

      {/* Medicare Based Config Tab */}
      <CustomTabPanel value={selectedTab} index={5}>
        <MedicareBasedConfigTab />
      </CustomTabPanel>

      {/* Rules Tab */}
      <CustomTabPanel value={selectedTab} index={6}>
        <RulesTab />
      </CustomTabPanel>
    </Box>
  );
};

export default ContractTabSection;